import React from 'react';
import PropTypes from 'prop-types';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import TextField from '@mui/material/TextField';
import { DatePicker as ResponsiveDatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const DatePickerField = ({
  error,
  fullWidth,
  label,
  helperText,
  minDate,
  maxDate,
  name,
  onChange,
  readOnly,
  renderInput,
  required,
  sx,
  testId,
  value,
  variant,
  PopperProps,
  DialogProps,
}) => {
  const renderInputTextField = (params) => (
    <TextField
      {...params}
      error={error}
      fullWidth={fullWidth}
      helperText={helperText}
      required={required}
      sx={sx}
      variant={variant}
      data-testid={testId}
    />
  );
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ResponsiveDatePicker
        desktopModeMediaQuery="@media (min-width: 900px)" // TODO: HB-958 discuss min-width
        label={label}
        minDate={minDate}
        maxDate={maxDate}
        name={name}
        onChange={onChange}
        readOnly={readOnly}
        renderInput={renderInput || renderInputTextField}
        value={value}
        views={['year', 'month', 'day']}
        PopperProps={PopperProps}
        DialogProps={DialogProps}
      />
    </LocalizationProvider>
  );
};
DatePickerField.propTypes = {
  DialogProps: PropTypes.shape({}),
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  name: PropTypes.string,
  onChange: PropTypes.func,
  PopperProps: PropTypes.shape({}),
  readOnly: PropTypes.bool,
  renderInput: PropTypes.func,
  required: PropTypes.bool,
  sx: PropTypes.shape({}),
  testId: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  variant: PropTypes.string,
};
export default DatePickerField;
